import React, { useState, useEffect, useRef } from "react";

import Header from '../components/common/Header';
import HeroSection from "./HeroSection";
import "../Website.css";
import ImageButtonSection from "./PlayGround";
import JobSlider from "./JobTitleSlider";
import SeeInAction from "./BehindOurAi";
import FrequentQuation from "./FrequentlyQuations";
import ContactForm from "./ContactForm";
import SeeAction from "./SeeAction";
import CareerFooter from "./AboutUs/CareerFooter";
import { useLocation } from "react-router-dom";

function LandingPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const contactFormRef = useRef(null);
  const scrollToContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const yOffset = -50; // Adjust to your header height
          const y =
            el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          el.scrollIntoView({ top: y, behavior: "smooth" });
        }
      }, 100); // Delay ensures element is rendered
    }
  }, [location]);
  return (
    <>
      {/* Section WITH dot background */}
      <div
        className="tw-text-white tw-font-inter tw-w-full tw-relative tw-overflow-hidden scrollbar-hide"

      >
        <Header onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />

        {/* Dot Background */}
        <div
          className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-screen -tw-z-10"
          style={{
            backgroundColor: '#070709', // Fallback
            backgroundImage: `radial-gradient(rgba(126, 130, 153, 0.8) 1px, transparent 1px), linear-gradient(to bottom, #081933, #070709)`,
            backgroundSize: `30px 30px, 100% 100%`,
          }}
        />

        <main className="tw-relative tw-z-10">
          <HeroSection />
          <ImageButtonSection />
          <h2 className="tw-text-center tw-mt-20">Jobs & Internships that Match Your Story</h2>
          <JobSlider />
          <SeeInAction />
          <SeeAction onRequestDemo={scrollToContactForm} />
          <FrequentQuation />
        </main>
      </div>

      {/* ContactForm WITHOUT background */}
      <div ref={contactFormRef} className="tw-text-white tw-font-inter tw-w-full tw-relative tw-overflow-hidden tw-bg-black">
        <ContactForm />
      </div>

      {/* CareerFooter WITH background */}
      <div
        className="tw-text-white tw-font-inter tw-w-full tw-relative tw-overflow-hidden"

      >
        {/* Dot Background */}
        <div
          className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-screen -tw-z-10"
          style={{
            backgroundColor: '#070709', // Fallback
            backgroundImage: `radial-gradient(rgba(126, 130, 153, 0.8) 1px, transparent 1px), linear-gradient(to bottom, #081933, #070709)`,
            backgroundSize: `30px 30px, 100% 100%`,
          }}
        />

        <main className="tw-relative tw-z-10">
          <CareerFooter theme="dark" />
        </main>
      </div>
    </>
  );
}

export default LandingPage;
